// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"98":"d68a6246","136":"e1d9daf6","290":"c3ad9749","294":"423e3d60","357":"95c3be9d","422":"01d336d6","455":"1405c3bd","560":"889e1db0","565":"c045fb2e","737":"72e2f6fe","751":"f0f95f09","796":"2a68938c","808":"9c02676f","945":"50b951b3"}[chunkId] + ".js";
};